export const cookies = {
    consent: {
        headline: 'We are using cookies',
        declaration:
            'We are using cookies on our website. Some of which are essential, while others help us to improve your experience on this website.',
        acceptEssential: 'Essential',
        acceptMarketing: 'Marketing',
        acceptStatistics: 'Statistics',
        save: 'Save preferences',
        acceptAll: 'Accept all',
        revoke: 'Revoke all',
    },
    settings: {
        title: 'Cookie settings',
    }
};
